export class EventsRepository {
  private readonly getApiPath = (room: string) =>
    `${process.env.REACT_APP_USER_EVENTS_API_URL}/l/${room}/events`;
  private readonly postApiPath = () =>
    `${process.env.REACT_APP_USER_EVENTS_API_URL}/c`;
  private readonly deleteApiPath = (room: string) =>
    `${process.env.REACT_APP_USER_EVENTS_API_URL}/d/${room}/events`;

  get(room: string): Promise<any> {
    return new Promise((res, rej) => {
      fetch(this.getApiPath(room), {
        method: 'GET',
      })
        .then((response) => {
          if (response.ok) {
            return res(response.json());
          }
          return response;
        })
        .then((error) => {
          return rej(error);
        });
    });
  }

  post(room: string, startDatetime: string): Promise<any> {
    return new Promise((res, rej) => {
      fetch(this.postApiPath(), {
        method: 'POST',
        body: JSON.stringify({
          room,
          start_datetime: startDatetime,
        }),
      })
        .then((response) => {
          if (response.ok) {
            return res(response.json());
          }
          return response;
        })
        .then((error) => {
          return rej(error);
        });
    });
  }

  delete(room: string, startDatetime: string): Promise<any> {
    return new Promise((res, rej) => {
      fetch(this.deleteApiPath(room), {
        method: 'DELETE',
        body: JSON.stringify({
          start_datetime: startDatetime,
        }),
      })
        .then((response) => {
          if (response.ok) {
            return res(response.json());
          }
          return response;
        })
        .then((error) => {
          return rej(error);
        });
    });
  }
}
